import { Container } from "@dinahmoe/dmafjs-visual";
import { nodes } from "@dinahmoe/dmafjs-core";

class NetworkCategory extends Container {
  namespace = "network:category";

  handlers = {
    selected: this.handleAppearance,
    caseSelected: this.handleAppearance
  };

  init(node, event) {
    super.init(node, event);
    const content = this.wrapText(node.categoryName, node.maxCharsPerLine);
    if (!node._ids["category_name"]) {
      console.warn("network:category missing child 'category_name' — created without template children");
      return;
    }
    node._ids["category_name"]["text.content"] = content;
  }

  wrapText(text, maxChars) {
    if (!maxChars || maxChars <= 0) {
      return text;
    }

    const words = text.split(" ");
    const lines = [];
    let currentLine = "";

    for (const word of words) {
      const testLine = currentLine ? `${currentLine} ${word}` : word;

      if (testLine.length <= maxChars) {
        currentLine = testLine;
      } else {
        if (currentLine) {
          lines.push(currentLine);
        }
        currentLine = word;
      }
    }

    if (currentLine) {
      lines.push(currentLine);
    }

    return lines.join("<br>");
  }

  handleAppearance(node) {
    const plate = node._ids["plate"];
    const categoryName = node._ids["category_name"];
    const icon = node._ids["icon"];

    // Selected with no case open: solid white, pink text
    // Selected with case open: revert to translucent blur
    // Not selected: translucent blur
    const showSelected = node.selected && !node.caseSelected;

    if (showSelected) {
      if (plate) {
        plate["appearance.background"] = "rgba(255,255,255, 1)";
        plate["appearance.backdropBlur"] = 0;
        plate["border.width"] = 0;
      }
      if (categoryName) categoryName["text.color"] = "#CD288C";
      if (icon) {
        icon["source.imageId"] = "icon_minus";
        icon["source.fill"] = "#CD288C";
      }
    } else {
      if (plate) {
        plate["appearance.background"] = "rgba(255,255,255, 0.1)";
        plate["appearance.backdropBlur"] = 10;
        plate["border.width"] = 1;
      }
      if (categoryName) categoryName["text.color"] = "#FFFFFF";
      if (icon) {
        icon["source.imageId"] = node.selected ? "icon_minus_white" : "icon_plus_white";
        icon["source.fill"] = "white";
      }
    }
  }

  receiveMessage(node, message) {
    super.receiveMessage(node, message);

    // Forward click events to container
    if (message.key === "click" && node.containerUid) {
      const containerNode = nodes.get(node.containerUid);
      containerNode.tell({
        type: "category_clicked",
        categoryUid: node.uid
      });
    }
  }
}

const networkCategory = new NetworkCategory();

export { NetworkCategory, networkCategory };
